
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crop-jpg",
      function () {
        return require("private-next-pages/crop-jpg/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crop-jpg"])
      });
    }
  